import { DefaultError, useMutation } from '@tanstack/react-query';
import { updateHabitGoalTaskOrder } from 'shared/services/backend-api';
import { ID } from 'shared/types/id';

export const useUpdateHabitGoalTaskOrderMutation = () =>
  useMutation<void, DefaultError, { goalId: ID; taskIds: ID[] }[]>({
    mutationFn: async (goalSorting) => updateHabitGoalTaskOrder(goalSorting),
  });
